import "core-js/stable";
import "regenerator-runtime/runtime";
import 'es6-promise/auto';
import 'classlist-polyfill';
import './dom-selector';
import _ from 'lodash';

// 내비게이션
window.addEventListener('scroll', e => {
    const wideNavEl = document.querySelector('.c-header-wide');
    if (window.pageYOffset === 0) {
        wideNavEl.classList.remove('c-header-wide--sticky');
    } else if (!wideNavEl.classList.contains('c-header-wide--sticky')) {
        wideNavEl.classList.add('c-header-wide--sticky');
    }
});

window.addEventListener('scroll', e => {
    const narrowNavEl = document.querySelector('.c-header-narrow');
    if (narrowNavEl) {
        if (window.pageYOffset === 0) {
            narrowNavEl.classList.remove('c-header-narrow--sticky');
        } else if (!narrowNavEl.classList.contains('c-header-narrow--sticky')) {
            narrowNavEl.classList.add('c-header-narrow--sticky');
        }
    }
});

window.addEventListener('keyup', e => {
    if (e.key === 'q' && ['textarea', 'input'].indexOf(e.target.tagName.toLowerCase()) === -1) {
        window.location.assign('https://p.marxism.or.kr/_MASTER/');
    }
});

window.textToggle = (selector) => {
    document.querySelector(selector).classList.toggle('u-hidden');
    document.querySelector(selector + '-up').classList.toggle('u-hidden');
    document.querySelector(selector + '-down').classList.toggle('u-hidden');
};

